import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
import { authClient } from '#pplx_generated/typespec/rest/auth/client.js';
const getSpecialProfile = async ({ profileName, reason, }) => {
    try {
        const { error, data, response } = await authClient.GET('/rest/auth/get_special_profile', reason, {
            params: { query: { profile_name: profileName } },
            timeoutMs: 1500,
            numRetries: 1,
        });
        if (error || !data) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                message: `Failed to get special profile ${profileName}`,
                cause: error,
                status: response.status ?? 0,
            });
        }
        return {
            unlimitedProSearch: Boolean(data.unlimited_pro_search),
            maxModelSelection: Boolean(data.max_model_selection),
            unlimitedResearch: Boolean(data.unlimited_research),
            fileUpload: Boolean(data.file_upload),
        };
    }
    catch (err) {
        logger.error(err);
        return {
            unlimitedProSearch: false,
            maxModelSelection: false,
            unlimitedResearch: false,
            fileUpload: false,
        };
    }
};
export const specialProfileQuery = {
    getKey: ({ profileName }) => QueryClientHelper.makeQueryKey('/rest/auth/get_special_profile', {
        profile_name: profileName,
    }),
    getOptions: ({ reason }, requestParams, overrideOptions) => ({
        queryKey: specialProfileQuery.getKey(requestParams),
        queryFn: () => getSpecialProfile({ ...requestParams, reason }),
        ...overrideOptions,
    }),
};
//# sourceMappingURL=specialProfileQuery.js.map